export default {
  PER_ADULT: 'PER_ADULT',
  PER_TRAVELER: 'PER_TRAVELER',
  TOTAL: 'TOTAL'
};